export default __webpack_public_path__ + "static/0293-5b76a1008b8f196130e56269fbabe10f.png";